const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{4,20}$/gu;

export const validation_rules = {
    email: (value) => {
        if (value) {
            if (!(value instanceof Array)) {
                return (!value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) && value.length > 0) ? 'Use a valid email address format' : '';
            }
        }
    },
    signUpEmail: value => ((!value.includes('@motorbikelogistics.co.uk') && !value.includes('@superbikefactory.co.uk') && !value.includes('@wewantyourmotorbike.com') && !value.includes('@superbikeloans.co.uk') && !value.includes('@ritebike.co.uk') && !value.includes('@webuyanybike.com')) ? 'Users must have a valid email address to sign up' : ''),
    createUserEmail: value => (!value.includes('@motorbikelogistics.co.uk') && !value.includes('@superbikefactory.co.uk') && !value.includes('@wewantyourmotorbike.com') && !value.includes('@superbikeloans.co.uk') && !value.includes('@ritebike.co.uk') && !value.includes('@webuyanybike.com') ? 'Email must have a suffix @superbikefactory.co.uk, @motorbikelogistics.co.uk, @ritebike.co.uk, @webuyanybike.com or @wewantyourmotorbike.com' : ''),
    isValueExist: value => (!value.length ? 'Field should not be empty' : ''),
    emailMatching: (emailAddress1, emailAddress2) => emailAddress1 !== emailAddress2 && 'Email addresses should match',
    passwordMatching: (password1, password2) => password1 !== password2 && 'Passwords should match',
    password: (value) => {
        if (value.length === 0) {
            return 'Field should not be empty';
        }
    },
    create_password: (value) => {
        const isPasswordValid = (passwordRegex).test(value);
        if (value.length === 0) {
            return 'Field should not be empty';
        } if (value.length <= 4) {
            return 'Password must have minimum 4 characters';
        } if (value.length >= 20) {
            return 'Password can only have a maximum of 20 characters';
        } if (!isPasswordValid) {
            return 'Must be at least one upper and lower case letter, and one numeric digit, one special char';
        }
    },
    create_cognito_password: (value) => {  
        if (value.length <= 8) {
            return 'Password must have minimum 8 characters';
        }  else if (!(/^(?=.*\d)/gu).test(value)) {
            return 'Must be at least one numeric digit';
        } else if (!(/^(?=.*[a-z])/gu).test(value)) {
            return 'Must be at least one lower case letter';
        } else if (!(/^(?=.*[A-Z])/gu).test(value)) {
            return 'Must be at least one upper case letter';
        } else if (!(/^(?=.*[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~])/gu).test(value)) {
            return 'Must be at least one special char';
        } else {
            return '';
        }
    },
    retail_price: value => (!value.length ? 'Field should not be empty' : ''),
    valuation: value => (value > 35000 ? 'Valuation should be no more than £35,000' : ''),
};



// WEBPACK FOOTER //
// ./src/shared/validation_rules.js